var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51088 9.08531V9.99123H5.2663V9.08531H10.5326V9.99123H12.288V9.08531H15.7988V12.256C15.7988 13.5072 14.8167 14.5209 13.6046 14.5209H2.19432C0.982175 14.5209 4.19617e-05 13.5072 4.19617e-05 12.256V9.08531H3.51088ZM12.288 7.27346V6.36753H10.5326V7.27346H5.2663V6.36753H3.51088V7.27346H4.19617e-05V5.91457C4.19617e-05 4.66346 0.982175 3.64976 2.19432 3.64976H4.38859V2.29087C4.38859 1.04523 5.37602 0.026062 6.58287 0.026062H9.216C10.4229 0.026062 11.4103 1.04523 11.4103 2.29087V3.64976H13.6046C14.8167 3.64976 15.7988 4.66346 15.7988 5.91457V7.27346H12.288ZM9.65486 2.29087C9.65486 2.04538 9.45385 1.83791 9.216 1.83791H6.58287C6.34503 1.83791 6.14401 2.04538 6.14401 2.29087V3.64976H9.65486V2.29087Z",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.cc3635e744fbe51191f810e7cc3aa581.svg";
export { ForwardRef as ReactComponent };